import { createContext } from 'react';
import { DroppingEntity } from './DroppingEntityContext';

export default createContext<(droppingEntity?: DroppingEntity) => void>(undefined);
